export default __webpack_public_path__ + "static/media/maisons_laffitte9.6da4f711.jpg";